import * as locomotive from './locomotive';
import * as cursor from './cursor.js';

export default (node) => {
	const play_text = node.dataset.textPlay;
	const pause_text = node.dataset.textPause;
	const btn_sound = node.parentNode.querySelector('.js-video-sound');

	node.addEventListener('play', () => {
		node.setAttribute('data-cursor-text', pause_text);
	});

	node.addEventListener('pause', () => {
		node.setAttribute('data-cursor-text', play_text);
	});

	if (btn_sound) {
		btn_sound.addEventListener('click', () => {
			node.muted = !node.muted;

			if (!node.muted) {
				btn_sound.classList.add('active');
				return;
			}

			btn_sound.classList.remove('active');
		});
	}

	node.addEventListener('click', () => {
		node.classList.add('active');
		
		if (node.paused) {
			node.play();
			cursor.text(pause_text);
			return;
		}

		node.pause();
		cursor.text(play_text);
	});
};